import { IAirportOption, IAirportOptionMap } from "../redux/reducers/StructuresReducer"; //IAirportSearchMap
import { IAirport, IFilterOption } from "@vmosolutions/oc-interfaces";
import { Auth, API } from "aws-amplify";
//import { Type } from "../redux/actions/Mosaic.Actions";
import { Dispatch } from "redux";
import { addAirportToList } from "../redux/actions/Structure.Actions";
import { AirportRequestMultiplexer } from "./airportCache";

// If provided an airport ident string, will filter the airportOptions array to find it.
export const filterAirports = (ident: string, airportOptions: IAirportOption[]): IAirportOption[] => {
  if (!ident || ident.length < 2) {
    return [];
  }
  const upper = ident.toUpperCase();
  const airportObj = airportOptions.filter((airportOption: IAirportOption) => {
    const checkIdent = airportOption.ident.includes(upper);
    if (checkIdent) {
      return true; // If ident is found, return match, otherwise search name.
    }
    return airportOption.name.includes(upper);
  });
  return airportObj;
};

// Returns an array of Full IAirport objects
export const findAirports = async (ident: string): Promise<IAirport[]> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();
  const airports = await API.get("skytrains", `/searchAirports?searchStr=${ident}`, {
    headers: { Accept: "*/*", Authorization: token },
  });
  if (airports) {
    return airports;
  } else return [];
};

export const formatIdentFromAirport = (ident: string, airportOptions: IAirportOption[]): IAirportOption[] => {
  const airport = airportOptions.find((airportOption: IAirportOption) => airportOption.ident === ident);
  return airport ? [airport] : [];
};

/**
 * A function to help with taking in multiple selected airports and returning a format to be displayed
 * in the form select value
 * @param filterOptions -
 * @param airportOptions -
 */
export const formatIdentMultipleAirports = (
  filterOptions: IFilterOption,
  airportOptions: IAirportOption[]
): IAirportOption[] => {
  const options = filterOptions?.searchValue?.map((searchValue: any) =>
    airportOptions.find((airportOption: IAirportOption) => airportOption.ident === searchValue.ident)
  );
  return options ?? [];
};

export const airportSearchString = "Search for airport name or IATA code";

// If new airport ident is selected, find it in the airport list and update the
// searchedAirports array in redux structures. If already in the searchedArray, return.
export const updateAirportOptions = async (
  ident: string,
  airportOptions: IAirportOptionMap,
  dispatch: Dispatch
): Promise<void> => {
  if (!ident || ident.length < 3 || airportOptions[ident]) {
    return;
  }
  await AirportRequestMultiplexer.dispatchAirportGetAirport(ident, (airports) =>
    dispatch(addAirportToList(ident, airports))
  );
};

const FALLBACK_TAXI_MINUTES = 5;

// Resolve default taxi-out minutes for a departing airport. Priority:
//   1. airport-level override (allows 0 for helicopter ops)
//   2. customer-level default
//   3. hardcoded 5-minute fallback
export const resolveDefaultTaxiOutMinutes = (
  airport: IAirport | IAirportOption | undefined,
  customerDefault: number | null | undefined
): number => {
  if (typeof airport?.defaultTaxiOutMinutes === "number") return airport.defaultTaxiOutMinutes;
  if (typeof customerDefault === "number") return customerDefault;
  return FALLBACK_TAXI_MINUTES;
};

// Resolve default taxi-in minutes for an arriving airport. See resolveDefaultTaxiOutMinutes for priority.
export const resolveDefaultTaxiInMinutes = (
  airport: IAirport | IAirportOption | undefined,
  customerDefault: number | null | undefined
): number => {
  if (typeof airport?.defaultTaxiInMinutes === "number") return airport.defaultTaxiInMinutes;
  if (typeof customerDefault === "number") return customerDefault;
  return FALLBACK_TAXI_MINUTES;
};
